import store from "@/shared/store";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { resetPayment } from "@/shared/scripts/ValidateData";
import { isBillboardTaxedPostalCode } from "@/shared/scripts/helpers/customer/billingAddress";

export type BillboardBlocker = "property" | "municipality" | "billing" | null;

export function billboardBlockedBy(): BillboardBlocker {
    const propertyCountry = store.getters["FormModule/getValue"]("property.location.address.country");
    const currentCustomer = store.getters["CustomersModule/getCurrentCustomer"];
    const billingCountry = currentCustomer?.location?.address?.provided?.country;

    if (propertyCountry && propertyCountry !== "BE") {
        return "property";
    }
    if (isBillboardTaxedPostalCode(store.getters["FormModule/getValue"]("property.location.address.postalCode"))) {
        return "municipality";
    }
    if (billingCountry && billingCountry !== "BE") {
        return "billing";
    }
    return null;
}

export function removeBillboardAndNotify(): Promise<boolean> {
    const blocker = billboardBlockedBy();
    if (blocker === null) {
        return Promise.resolve(false);
    }

    const selected = store.getters["FormModule/getValueTransaction"]("optimizedEncoding.selectedPackOptions") || {};
    let hadBillboard = false;
    const next: Record<string, any> = {};

    for (const packKey of Object.keys(selected)) {
        const opts = selected[packKey] || {};
        if (opts.billboard) {
            hadBillboard = true;
        }
        next[packKey] = { ...opts, billboard: null };
    }

    if (!hadBillboard) {
        return Promise.resolve(false);
    }

    store.commit("FormModule/addValueTransaction", { path: "optimizedEncoding.selectedPackOptions", value: next });
    store.commit("FormModule/addValueTransaction", { path: "transaction.pricing.billboard", value: null });

    // An order may already exist (user reached payment with billboard). Invalidate it
    // and collapse the payment section so the order is rebuilt without billboard.
    resetPayment();

    return store.dispatch("Dialog/alert", {
        okLabel: "OK",
        message: i18n.t(blocker === "municipality"
            ? "billboard_unavailable_municipality_tax"
            : "billboard_removed_non_belgian_address").toString(),
    });
}
